import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import Stepper from '@mui/material/Stepper'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'
import { sendAnalyticsEvent } from '../../../analytics'
import DashboardLayout from '../../../components/ui/DashboardLayout'
import { LoaderIcon } from '../../../components/ui/Swicons'
import { STEPS, devURL, titleCase } from '../../../utils'

export default function AddTransaction({ send_amount }) {
  const token = localStorage.getItem('swToken')
  // const { register, handleSubmit } = useForm();
  const [oneEuroInr, setEuroToInr] = useState(0)
  const [output, setOutput] = useState('')
  const [val, setVal] = useState(send_amount)
  const [input, setInput] = useState(val)
  const [loader, isLoading] = useState(false)
  const [receivedAmount, setReceivedAmount] = useState(0)
  const [rate, setRate] = useState(0)
  const [recipientData, setRecipientData] = useState([])
  const [dataIdName, setDataIdName] = useState({})
  const [isDisabledLogin, setDisabledLogin] = useState(true)
  const initialValues = { recipient_id: '', sent_amount: '', comments: '' }
  const [formValues, setFormValues] = useState(initialValues)
  const [nameVal, setNameVal] = useState('')
  const [rec_name, setRec_name] = useState('')
  const [userProData, setUserProfileData] = useState([])
  const [userEmail, setUserEmail] = useState()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    getTransactionDetails({ target: { value: send_amount } })
  }, [send_amount])

  useEffect(() => {
    getRecipientsData()
    getUserProfileData()
  }, [])

  useEffect(() => {
    if (
      formValues.recipient_id !== '' &&
      formValues.sent_amount !== '' &&
      formValues.comments !== ''
    ) {
      setDisabledLogin(false)
    } else {
      setDisabledLogin(true)
    }
  }, [formValues])

  const handelINRChange = (e) => {
    let eur = e.target.value / rate
    if (eur <= 15000) {
      setOutput(e.target.value)
      setInput(eur.toFixed(2))
      setFormValues((val) => ({
        ...val,
        sent_amount: (e.target.value / rate).toFixed(2),
      }))
      setReceivedAmount(e.target.value)
    } else {
      return toast.error('The most you can send is 15,000 EUR.')
    }
  }

  const handleChange = (e) => {
    if (e.target.name === 'comments' && e.target.value.length >= 0) {
      setFormValues((val) => ({ ...val, comments: e.target.value }))
    }
  }

  const getRecipientsData = () => {
    axios
      .get(`${devURL}/recipient/all`, {
        headers: { token: token },
      })
      .then((res) => {
        setRecipientData(res.data)
        let reSultDisc = {}
        res.data.map(
          (recipient, index) =>
            (reSultDisc[recipient._id] =
              recipient.recipient_name +
              ' (' +
              recipient.recipient_nick_name +
              ')')
        )
        let names = {}
        res.data.map(
          (recipient, index) =>
            (names[titleCase(recipient.recipient_name)] = recipient._id)
        )
        console.log(formValues.recipient_id)
        setDataIdName(reSultDisc)
        setRec_name(names)
        if (location.state) {
          setFormValues((val) => ({
            ...val,
            recipient_id: location.state.recipient._id,
          }))
          setNameVal(titleCase(location.state.recipient.recipient_name))
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          toast.error('Session expired please login again')
          localStorage.removeItem('swToken')
          navigate('/Login')
        }
        console.log(err)
      })
  }

  const getTransactionDetails = (e) => {
    setFormValues((val) => ({ ...val, sent_amount: e.target.value }))
    if (e.target.name === 'sent_amount' && e.target.value.length >= 0) {
      setVal(e.target.value)
      setInput(e.target.value)
      setOutput((e.target.value * oneEuroInr).toFixed(2))
    }
    if (e.target.value > 15000) {
      toast.error('Your send amount should be less than 15000 EUR!')
    } else if (e.target.value <= 15000) {
      const URL = `${devURL}/user/getRate`
      axios
        .get(URL, {
          headers: {
            accept: 'application/json',
          },
        })
        .then((response) => {
          let rate = response.data.rate
          setEuroToInr(rate)
          setRate(rate)
          setReceivedAmount((e.target.value * rate).toFixed(2))
          setOutput((e.target.value * rate).toFixed(2))
        })

        .catch((error) => {
          console.log('error ' + error)
        })
    }
  }

  const getUserProfileData = () => {
    axios
      .get(`${devURL}/user/get-user-info`, {
        headers: { token: token },
      })
      .then((res) => {
        if (res.data) {
          //console.log(res.data);
          setUserProfileData(res.data)
          setUserEmail(res.data.email)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const resendEmailVerify = () => {
    async function callApi() {
      await axios
        .post(
          `${devURL}/user/send-activation-email`,
          { email: userEmail },
          { headers: { token: token } }
        )
        .then((res) => {
          if (res.data.status) {
            //console.log(res.data);
            Swal.fire({
              title: res.data.message,
              confirmButtonColor: '##2878bb',
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
    callApi()
    //console.log(userEmail);
  }

  const onSubmit = (e) => {
    e.preventDefault()
    if (formValues.recipient_id === '') {
      toast.error('Please select recipient.')
      isLoading(false)
    } else if (dataIdName[formValues.recipient_id] == undefined) {
      toast.error('Please select an existing recipient.')
      isLoading(false)
    } else if (formValues.sent_amount === '') {
      toast.error('Please enter send amount.')
      isLoading(false)
    } else if (formValues.sent_amount > 15000) {
      toast.error('Your send amount should be less than 15000 EUR!')
      isLoading(false)
    } else if (formValues.sent_amount < 0) {
      toast.error('Your send amount should be greater than 0 EUR!')
      isLoading(false)
    } else if (formValues.comments === '') {
      toast.error('Please enter comment.')
      isLoading(false)
    } else if (
      userProData.doc_submitted === false &&
      userProData.is_verified === false &&
      userProData.dfns_wallet_id == ''
    ) {
      Swal.fire({
        title: 'Please check your profile and verify your details',
        position: 'center',
        icon: 'warning',
        confirmButtonText: 'Sure',
        showCancelButton: false,
        showDenyButton: true,
        denyButtonText: 'Cancel',
        denyButtonColor: '#3391e2',
        confirmButtonColor: '#2878bb',
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/myprofile?fromDashboard=kyc')
        }
      })
      isLoading(false)
    } else if (userProData.is_verified === false) {
      Swal.fire({
        title: 'Please verify your email',
        position: 'center',
        icon: 'warning',
        confirmButtonText: 'Sure',
        showCancelButton: true,
        cancelButtonText: 'Later',
        confirmButtonColor: '#2878bb',
      }).then((result) => {
        if (result.isConfirmed) {
          resendEmailVerify()
        }
      })
      isLoading(false)
    } else if (userProData.doc_submitted === false) {
      Swal.fire({
        title: 'Please complete your KYC',
        position: 'center',
        icon: 'warning',
        confirmButtonText: 'Sure',
        showCancelButton: true,
        cancelButtonText: 'Later',
        confirmButtonColor: '#2878bb',
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/myprofile?fromDashboard=kyc')
        }
      })
      isLoading(false)
    } else if (userProData.dfns_wallet_id == '') {
      Swal.fire({
        title: 'Please  verify your digital wallet',
        position: 'center',
        icon: 'warning',
        confirmButtonText: 'Sure',
        showCancelButton: true,
        cancelButtonText: 'Later',
        confirmButtonColor: '#2878bb',
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/myprofile?fromDashboard=dfns')
        }
      })
      isLoading(false)
    } else {
      let info = {}
      info.rate = rate
      info.received_amount = receivedAmount
      isLoading(true)
      info.src_currency = 'EUR'
      info.dest_currency = 'INR'
      info.fee = '0'
      Swal.fire({
        title: 'Please Confirm details',
        html:
          '<div class="text-left text-slate-600">' +
          '<b>Recipient Name :</b> ' +
          titleCase(dataIdName[formValues.recipient_id]) +
          '<br />' +
          '<b>Send Amount :</b> ' +
          formValues.sent_amount +
          ' ' +
          info.src_currency +
          ' <br />' +
          '<b>Received Amount :</b> ' +
          info.received_amount +
          ' ' +
          info.dest_currency +
          ' <br />' +
          '<b>Rate :</b> 1 EUR - ' +
          info.rate.toFixed(2) +
          ' INR<br />' +
          '<b>Fee :</b> ' +
          info.fee +
          ' <br />' +
          '<b>Comment :</b> ' +
          formValues.comments +
          '<br />' +
          '</div>',
        dangerMode: true,
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        confirmButtonColor: '#2878bb',
        cancelButtonColor: '#EA0000',
      }).then((result) => {
        if (result.isDenied) {
          isLoading(false)
        }
        if (result.isConfirmed) {
          axios
            .post(
              `${devURL}/transfer/add`,
              { ...info, ...formValues },
              {
                headers: { token: token },
              }
            )
            .then((res) => {
              isLoading(false)
              Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Transaction added successfully!',
                showConfirmButton: false,
                timer: 1500,
              })
              //toast.success("Transaction added successfully!");
              sendAnalyticsEvent('transaction', {
                category: 'transaction',
                action: 'transaction_added',
                label: 'transaction_added',
              })
              navigate('/Transaction-Details/recent')
            })
            .catch((err) => {
              isLoading(false)
              if (
                err.response &&
                err.response.data &&
                err.response.data.errorMessage
              ) {
                toast.error(err.response.data.errorMessage)
              }
            })
        } else {
          isLoading(false)
        }
      })
    }
  }

  const handleName = (e) => {
    setNameVal(e.target.value)
    if (e.target.name === 'recipient_id' && e.target.value.length >= 0) {
      setFormValues((val) => ({
        ...val,
        recipient_id: rec_name[titleCase(e.target.value)],
      }))
    }
  }

  return (
    <DashboardLayout>
      <div className='lg:p-12 pt-4 px-4 ml-2 mx-auto'>
        <Stepper activeStep={0} alternativeLabel>
          {STEPS.map((label) => (
            <Step key={label}>
              <StepLabel>
                <div className='text-xs lg:text-lg'>{label}</div>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>
      <div className='page-title text-xl font-bold mt-6 lg:mt-0'>
        <p>Send Money</p>
      </div>
      <div className='sw-add-recipient-form mt-6 flex justify-center pl-4'>
        <form onSubmit={onSubmit} className='w-[85%] lg:w-1/2'>
          <div className='grid grid-cols-3 gap-4 items-end mb-6'>
            <div className='col-span-2 flex flex-col gap-1'>
              <label
                htmlFor='recipient_id'
                className='text-gray-600 text-left font-bold'
              >
                Select recipient: <span className='text-red-600'>*</span>
              </label>
              <input
                onChange={handleName}
                value={nameVal}
                name='recipient_id'
                list='list'
                placeholder='Enter the recipient name'
                autoComplete='off'
                className='appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10'
              ></input>
              <datalist id='list'>
                {recipientData.length > 0 && (
                  <>
                    {recipientData.map((recipient, index) => {
                      if (!recipient.is_deleted) {
                        return (
                          <option
                            className='py-2'
                            value={titleCase(recipient.recipient_name)}
                            key={recipient._id}
                          >
                            ({recipient.recipient_nick_name})
                          </option>
                        )
                      }
                    })}
                  </>
                )}
              </datalist>
            </div>

            <Link
              to='/Add-Recipient'
              className='relative py-2 w-24 lg:w-36 border text-xs lg:text-base text-center border-transparent font-medium rounded-md text-white bg-themeColor hover:bg-themeHover'
            >
              + Add recipient
            </Link>
          </div>
          <div className='mb-6 flex flex-col gap-1'>
            <label
              htmlFor='sent_amount'
              className='text-gray-600 text-left font-bold'
            >
              Send amount:<span className='text-red-600'>*</span> EUR
            </label>
            <div className='flex'>
              <input
                name='sent_amount'
                value={input != 0.0 ? input : ''}
                onKeyPress={(event) => {
                  if (!/[0-9.]/.test(event.key)) {
                    event.preventDefault()
                  }

                  if (!/^(\d*\.{0,1}\d{0,1}$)/.test(event.target.value)) {
                    event.preventDefault()
                  }
                }}
                type='number'
                step='any'
                min='0'
                className='appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10'
                placeholder='Enter send amount EUR'
                onChange={getTransactionDetails}
              />

              <img
                className='w-8 h-6 ml-2 mt-2'
                src='/images/europe.png'
                alt='europe'
              />
            </div>
          </div>
          <div className='mb-6 flex flex-col gap-1'>
            <label
              htmlFor='received_amount'
              className='text-gray-600 text-left font-bold'
            >
              Received amount:<span className='text-red-600'>*</span> INR
            </label>
            <div className='flex'>
              <input
                onChange={handelINRChange}
                onKeyPress={(event) => {
                  if (!/[0-9.]/.test(event.key)) {
                    event.preventDefault()
                  }

                  if (!/^(\d*\.{0,1}\d{0,1}$)/.test(event.target.value)) {
                    event.preventDefault()
                  }
                }}
                name='received_amount'
                step='any'
                type='number'
                className='appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:ring-indigo-500 focus:border-indigo-500 focus:z-10'
                placeholder='Enter send amount INR'
                value={output != 0.0 ? output : ''}
              />
              <img
                className='w-8 h-8 ml-2 mt-1'
                src='/images/india.png'
                alt='india'
              />
            </div>
          </div>
          <div className='mb-6 flex flex-col gap-1'>
            <label htmlFor='rate' className='text-gray-600 text-left font-bold'>
              Rate:<span className='text-red-600'>*</span>{' '}
              <span>1 EUR - INR</span>
            </label>
            <input
              onChange={handleChange}
              name='rate'
              className='appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 '
              placeholder='Enter rate'
              value={rate.toFixed(2)}
              disabled={true}
            />
          </div>
          <div className='mb-6 flex flex-col gap-1'>
            <label htmlFor='fee' className='text-gray-600 text-left font-bold'>
              Fee:<span className='text-red-600'>*</span>
            </label>
            <input
              onChange={handleChange}
              name='fee'
              className='appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10'
              placeholder='Enter fee'
              defaultValue='0.00'
              disabled={true}
            />
          </div>
          <div className='mb-6 flex flex-col gap-1'>
            <label
              htmlFor='comments'
              className='text-gray-600 text-left font-bold'
            >
              Purpose of transfer:<span className='text-red-600'>*</span>
            </label>
            <select
              onChange={handleChange}
              name='comments'
              className='appearance-none relative block w-full px-3 py-2 mb-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10'
              value={formValues.comments}
            >
              <option className='py-2' value=''>
                Select purpose
              </option>
              <option className='py-2' value='Family maintenance'>
                Family maintenance
              </option>
              <option className='py-2' value='Savings'>
                Savings
              </option>
              <option
                className='py-2'
                value='Deposit to Non-Resident Ordinary (NRO) accounts'
              >
                Deposit to Non-Resident Ordinary (NRO) accounts
              </option>
              <option className='py-2' value='Payments to friends'>
                Payments to friends
              </option>
              <option className='py-2' value='Other personal expenses'>
                Other personal expenses
              </option>
              <option
                className='py-2'
                value='Education related expenses for family'
              >
                Education related expenses for family
              </option>
              <option className='py-2' value='Medical treatment for family'>
                Medical treatment for family
              </option>
              <option className='py-2' value='Property purchase'>
                Property purchase
              </option>
            </select>
            {/* <textarea
              {...register("comments")}
              onChange={handleChange}
              name="comments"
              className="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
              placeholder="Enter comment"
              row="10"
            ></textarea> */}
          </div>

          <div className='mb-6'>
            <button
              type='submit'
              className='group relative py-2 px-4 border border-transparent font-medium rounded-md text-white bg-themeColor hover:bg-themeHover'
              // style={{ backgroundColor: "#5C6E64" }}
              style={
                !isDisabledLogin
                  ? { backgroundColor: '#246eaa' }
                  : { backgroundColor: '#246eaa', opacity: '50%' }
              }
              disabled={isDisabledLogin}
            >
              {loader && <LoaderIcon />}
              {!loader && <>Send Money</>}
            </button>
          </div>
        </form>
      </div>
    </DashboardLayout>
  )
}
